import { createRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { routesModel } from '../router.consts.ts';
import { RoutesMap } from '../router.types.ts';
import { HomeAddressPage, IdentityPage, PersonalDetailsPage, PhonePage } from '../index.ts';
import { beforeLoadGeneral } from '@Router/middleware.ts';
import { useBoundStore } from '@Store/useBoundStore.ts';
import { SplashScreen } from '@Components/splash/SplashScreen.tsx';
import { router } from '@Routes/__root.tsx';
import { GeneralSpinner } from '@Components/generalSpinner.tsx';
import { rootRoute } from './rootRoute.tsx';
import { WelcomePage } from '@Pages/passwordless/welcome/WelcomePage.tsx';

const getObData = useBoundStore.getState().onboardingSlice.getOnboardingData;

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    if (getObData().isLoginProcessFinished) {
      throw router.navigate({ to: routesModel[RoutesMap.WELCOME].path });
    }
  },
  component: () => <SplashScreen />,
});

const welcomeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.WELCOME].path,
  beforeLoad: () => {
    // dataLayerHandler(GTMEventLabel.START);
    beforeLoadGeneral({
      page: RoutesMap.WELCOME,
      shouldUpdateServerNavStack: true,
      shouldAvoidAuthCheck: true,
    });
  },
  component: () => <Suspense fallback={<GeneralSpinner />}>{<WelcomePage />}</Suspense>,
});

const phoneRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.PHONE].path,
  beforeLoad: () => {
    beforeLoadGeneral({ page: RoutesMap.PHONE, shouldUpdateServerNavStack: true });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <PhonePage />
    </Suspense>
  ),
});

const identityRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.IDENTITY].path,
  beforeLoad: () => {
    beforeLoadGeneral({ page: RoutesMap.IDENTITY, shouldUpdateServerNavStack: true });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <IdentityPage />
    </Suspense>
  ),
});

const HomeAddressRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.HOME_ADDRESS].path,
  beforeLoad: () => {
    beforeLoadGeneral({ page: RoutesMap.HOME_ADDRESS, shouldUpdateServerNavStack: true });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <HomeAddressPage />
    </Suspense>
  ),
});
const PersonalDetailsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.PERSONAL_DETAILS].path,
  beforeLoad: () => {
    beforeLoadGeneral({ page: RoutesMap.PERSONAL_DETAILS, shouldUpdateServerNavStack: true });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <PersonalDetailsPage />
    </Suspense>
  ),
});
export const personalRoutes = [
  indexRoute,
  welcomeRoute,
  phoneRoute,
  identityRoute,
  HomeAddressRoute,
  PersonalDetailsRoute,
];
